/*
 * NuovaGlam Poêle titane — cohérence panier des lots (bundle 1/2/3 + cadeaux).
 * Chargé seulement sur la fiche Poêle ou quand le panier contient une ligne Poêle (layout/theme.liquid).
 * Source de vérité = panier Shopify réel. Chaque lot = un groupe _ng_pan_bundle_id ; tout se juge PAR GROUPE,
 * jamais sur la quantité globale du produit. Idempotent : relancer la réconciliation ne crée aucun doublon.
 * Standard : brain/knowledge/standards/bundles-upsells-shopify.md §6ter et §11 (une variante par palier).
 */
(() => {
  if (window.__ngPanCartSync) return;
  window.__ngPanCartSync = true;
  const script = document.currentScript;
  const PAN_PRODUCT_ID = 16035915596107;
  const GIFTS = { 2: [{ key: 'spatula', variant: 58623612748107 }], 3: [{ key: 'board', variant: 58623614026059 }, { key: 'spatula', variant: 58623612748107 }] };
  /* Guide PDF (14/10/2026) : cadeau numérique ajouté par la fiche sur toutes les offres quand il est activé dans l'éditeur.
     La synchro le CONSERVE (quantité 1, sans doublon) mais ne l'ajoute pas d'elle-même : désactivé dans l'éditeur = jamais forcé. */
  const GUIDE = { key: 'guide', variant: 58831183118667 };
  /* Couvercles (25/10/2026, sa demande) : un couvercle offert = une VRAIE ligne de commande, comme la spatule, pour
     qu'il apparaisse dans la commande Admin. Produit cadeau « NuovaGlam™ Lid » (SKU NG-PAN-GIFT-LID-<taille>, 0 €),
     une ligne par taille, quantité = nombre de poêles de cette taille dont le SKU porte « -LID » (Duo et Kit). */
  const LIDS = { 22: 58990822129995, 24: 58990822162763, 26: 58990822195531, 28: 58990822228299, 30: 58990822261067 };
  const LID_KEY = 'lid';
  const LID_VARIANTS = Object.values(LIDS);
  const GIFT_VARIANTS = [58623612748107, 58623614026059, GUIDE.variant, ...LID_VARIANTS];
  const POLICY = (script && script.dataset.policy) || 'single';
  const IT = (document.documentElement.lang || '').toLowerCase().startsWith('it');
  const GIFT_KEY = IT ? 'Omaggio' : 'Gift';
  const GIFT_VALUE = IT ? { 2: 'Incluso nel set da 2 padelle', 3: 'Incluso nel set da 3 padelle' } : { 2: 'Included with the 2-pan set', 3: 'Included with the 3-pan set' };
  const GUIDE_VALUE = IT ? "Inviata via e-mail dopo l'ordine" : 'Sent by email after your order';
  const OFFER_KEY = IT ? 'Offerta' : 'Offer';
  const OFFER_VALUE = IT ? { 1: '1 padella', 2: 'Set da 2 padelle', 3: 'Set da 3 padelle' } : { 1: '1 pan', 2: '2-pan set', 3: '3-pan set' };
  /* Offre « Optimisation n°2 » (24/10/2026) : UNE VARIANTE PAR PALIER (règle 37). Le prix de chaque poêle est
     celui de SA variante (taille × palier) ; plus aucune remise automatique à reproduire ici. Changer de palier
     au panier = CHANGER DE VARIANTE : chaque ligne poêle porte, dans sa propriété privée _ng_pan_cfg, la variante
     de sa taille dans les 3 paliers (même principe que _ng_wm_cfg du Washer, 18/10/2026). Une ligne posée avant
     ce changement n'a pas de cfg : son − / + garde alors sa variante, donc son prix reste celui qu'elle a payé. */
  const RATES = { 1: 'variant-S1', 2: 'variant-D2', 3: 'variant-K3' };
  const tierVariant = (item, units) => {
    try {
      const cfg = JSON.parse(item.properties?._ng_pan_cfg || 'null');
      const id = cfg && Array.isArray(cfg.t) ? Number(cfg.t[units - 1]) : 0;
      return id > 0 ? id : item.variant_id;
    } catch (e) {
      return item.variant_id;
    }
  };
  const route = (path) => (window.Shopify?.routes?.root || '/') + path;
  const isPan = (item) => item.product_id === PAN_PRODUCT_ID;
  const isGiftVariant = (item) => GIFT_VARIANTS.includes(item.variant_id);
  const groupOf = (item) => item.properties?._ng_pan_bundle_id || '';
  const isGuide = (item) => item.variant_id === GUIDE.variant && item.properties?._ng_pan_gift === GUIDE.key;
  const isLid = (item) => LID_VARIANTS.includes(item.variant_id) && item.properties?._ng_pan_gift === LID_KEY;
  const sizeOf = (item) => {
    try {
      const cfg = JSON.parse(item.properties?._ng_pan_cfg || 'null');
      if (cfg && cfg.s) return parseInt(cfg.s, 10) || 0;
    } catch (e) { /* cfg illisible : taille lue sur l'option */ }
    return parseInt((item.variant_options || [])[0], 10) || 0;
  };
  /* Poêle vendue AVEC couvercle = SKU « NG-PAN-<taille>-LID-… » (Duo, Kit). ⛔ Pas un simple « contient -LID » :
     le palier 1 s'écrit « NG-PAN-<taille>-NO-LID-… » et le contient aussi (piège mesuré le 25/10/2026). */
  const hasLid = (item) => /-\d{2}-LID-/.test(String(item.sku || ''));
  /* Couvercles attendus : variante de couvercle → quantité, d'après les poêles avec couvercle données. */
  const lidsFor = (rows) => {
    const wanted = new Map();
    rows.forEach(({ item, quantity }) => {
      const id = LIDS[sizeOf(item)];
      if (id) wanted.set(id, (wanted.get(id) || 0) + quantity);
    });
    return wanted;
  };

  async function readCart() {
    const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('cart unavailable');
    return response.json();
  }
  async function post(path, body) {
    const response = await fetch(route(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (!response.ok) throw new Error(`${path} ${response.status}`);
    return response.json();
  }

  /* Calcul pur : ce qu'il faut retirer / ajouter pour que chaque groupe soit exact. Exposé pour les tests. */
  function plan(cart) {
    const groups = new Map();
    const updates = {};
    const additions = [];
    for (const item of cart.items) {
      const id = groupOf(item);
      if (id) { if (!groups.has(id)) groups.set(id, []); groups.get(id).push(item); }
      else if (isGiftVariant(item)) updates[item.key] = 0; /* cadeau Poêle hors groupe = orphelin */
    }
    const valid = [];
    for (const [id, lines] of groups) {
      const pans = lines.filter(isPan);
      const count = Number(pans[0]?.properties?._ng_pan_offer);
      const units = pans.reduce((total, item) => total + item.quantity, 0);
      const coherent = [1, 2, 3].includes(count) && pans.length > 0 && units === count && pans.every((item) => Number(item.properties?._ng_pan_offer) === count);
      if (!coherent) { lines.forEach((item) => { updates[item.key] = 0; }); continue; }
      valid.push(id);
      const expected = GIFTS[count] || [];
      const lids = lidsFor(pans.filter(hasLid).map((item) => ({ item, quantity: item.quantity })));
      const seen = new Set();
      const seenLids = new Set();
      for (const item of lines) {
        if (isPan(item)) continue;
        if (isLid(item)) {
          const want = lids.get(item.variant_id) || 0;
          if (!want || seenLids.has(item.variant_id)) { updates[item.key] = 0; continue; }
          seenLids.add(item.variant_id);
          if (item.quantity !== want) updates[item.key] = want;
          continue;
        }
        if (isGuide(item)) {
          if (seen.has(GUIDE.key)) { updates[item.key] = 0; continue; }
          seen.add(GUIDE.key);
          if (item.quantity !== 1) updates[item.key] = 1;
          continue;
        }
        const gift = expected.find((g) => g.variant === item.variant_id && g.key === item.properties?._ng_pan_gift);
        if (!gift || seen.has(gift.key)) { updates[item.key] = 0; continue; } /* cadeau étranger ou en double */
        seen.add(gift.key);
        if (item.quantity !== 1) updates[item.key] = 1; /* un cadeau = quantité 1, jamais plus */
      }
      for (const gift of expected) {
        if (seen.has(gift.key)) continue; /* cadeau manquant → ré-ajouté, dans le même groupe */
        const offerProps = pans[0].properties;
        additions.push({ id: gift.variant, quantity: 1, properties: { _ng_pan_bundle_id: id, _ng_pan_offer: String(count), _ng_market_offer: offerProps._ng_market_offer || '', _ng_pan_gift: gift.key, [GIFT_KEY]: GIFT_VALUE[count] } });
      }
      for (const [variant, quantity] of lids) {
        if (seenLids.has(variant)) continue; /* couvercle manquant (panier d'avant le 25/10 compris) → ajouté */
        additions.push({ id: variant, quantity, properties: { _ng_pan_bundle_id: id, _ng_pan_offer: String(count), _ng_market_offer: pans[0].properties._ng_market_offer || '', _ng_pan_gift: LID_KEY, [GIFT_KEY]: GIFT_VALUE[count] } });
      }
    }
    /* Remises natives = seuil de quantité panier : tant qu'aucune remise par groupe n'existe, un seul lot Poêle (le plus récent). */
    if (POLICY === 'single' && valid.length > 1) {
      const newest = valid.slice().sort().pop();
      for (const id of valid) if (id !== newest) groups.get(id).forEach((item) => { updates[item.key] = 0; });
      for (let i = additions.length - 1; i >= 0; i -= 1) if (additions[i].properties._ng_pan_bundle_id !== newest) additions.splice(i, 1);
    }
    return { updates, additions };
  }

  /* Vitesse (21/10/2026, brain/knowledge/standards/vitesse-page-panier.md) : le tiroir re-rendu est demandé DANS la
     dernière mutation (sections + sections_url, API Ajax Shopify) au lieu d'un aller-retour de plus après elle. */
  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const withSections = (body) => (document.querySelector('cart-drawer') ? { ...body, sections: SECTIONS, sections_url: window.location.pathname } : body);

  async function refreshUI(given) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const sections = given && typeof given['cart-drawer'] === 'string' ? given : await (await fetch(`${route('')}?sections=${SECTIONS}`)).json();
      if (sections['cart-drawer']) {
        const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const next = doc.querySelector('#CartDrawer');
        const current = document.getElementById('CartDrawer');
        if (next && current) current.innerHTML = next.innerHTML;
        const empty = doc.querySelector('cart-drawer')?.classList.contains('is-empty');
        drawer.classList.toggle('is-empty', Boolean(empty));
      }
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const next = doc.querySelector('.shopify-section');
        if (next) bubble.innerHTML = next.innerHTML;
      }
    }
    if (document.getElementById('main-cart-items')) window.location.reload(); /* page panier : rendu serveur complet (sous-total inclus) */
  }

  async function rebuildGroup(groupId, lineKey, delta) {
    const cart = await readCart();
    const lines = cart.items.filter((item) => groupOf(item) === groupId);
    const pans = lines.filter(isPan);
    const target = pans.find((item) => item.key === lineKey);
    if (!target) return false;

    const currentUnits = pans.reduce((sum, item) => sum + item.quantity, 0);
    const nextUnits = currentUnits + delta;
    if (nextUnits < 1 || nextUnits > 3) return false;

    const desired = [];
    for (const item of pans) {
      const quantity = item.key === lineKey ? item.quantity + delta : item.quantity;
      if (quantity > 0) desired.push({ item, quantity });
    }

    /* Le palier visé décide la variante de chaque poêle : son prix (et son prix barré) viennent de Shopify,
       donc le total du groupe après mutation est exactement celui de la carte du même palier sur la fiche. */
    const swapped = desired.map(({ item, quantity }) => ({ item, quantity, variantId: tierVariant(item, nextUnits) }));
    if (swapped.some((row) => !row.variantId)) return false;
    const market = String(pans[0]?.properties?._ng_market_offer || '').split('|')[0] || (IT ? 'IT' : 'IE');
    const common = {
      _ng_pan_bundle_id: groupId,
      _ng_pan_offer: String(nextUnits),
      _ng_market_offer: `${market}|PAN-${nextUnits}|${RATES[nextUnits]}`
    };

    let slot = 1;
    const items = swapped.map(({ item, quantity, variantId }) => {
      const slots = [];
      for (let i = 0; i < quantity; i += 1) slots.push(slot++);
      const properties = { ...common, _ng_pan_slots: `${slots.join('+')}/${nextUnits}` };
      if (nextUnits > 1) properties[OFFER_KEY] = OFFER_VALUE[nextUnits];
      if (item.properties?._ng_cart_image) properties._ng_cart_image = item.properties._ng_cart_image;
      if (item.properties?._ng_pan_cfg) properties._ng_pan_cfg = item.properties._ng_pan_cfg;
      return { id: variantId, quantity, properties };
    });

    const giftImages = new Map();
    lines.filter((item) => isGiftVariant(item) && !isGuide(item) && !isLid(item)).forEach((item) => {
      if (item.properties?._ng_cart_image) giftImages.set(item.variant_id, item.properties._ng_cart_image);
    });
    const giftItems = [];
    /* Duo et Kit (paliers 2 et 3) = variantes « -LID » : un couvercle de la même taille par poêle, en tête des
       cadeaux comme sur la carte de la fiche. */
    if (nextUnits >= 2) {
      for (const [variant, quantity] of lidsFor(swapped)) {
        giftItems.push({ id: variant, quantity, properties: { ...common, _ng_pan_gift: LID_KEY, [GIFT_KEY]: GIFT_VALUE[nextUnits] } });
      }
    }
    for (const gift of (GIFTS[nextUnits] || [])) {
      const properties = {
        ...common,
        _ng_pan_gift: gift.key,
        [GIFT_KEY]: GIFT_VALUE[nextUnits]
      };
      const image = giftImages.get(gift.variant);
      if (image) properties._ng_cart_image = image;
      giftItems.push({ id: gift.variant, quantity: 1, properties });
    }
    const guideLine = lines.find(isGuide);
    if (guideLine) {
      const properties = { ...common, _ng_pan_gift: GUIDE.key, [GIFT_KEY]: GUIDE_VALUE };
      if (guideLine.properties?._ng_cart_image) properties._ng_cart_image = guideLine.properties._ng_cart_image;
      giftItems.push({ id: GUIDE.variant, quantity: 1, properties });
    }
    items.push(...giftItems.reverse()); /* panier = plus récent d'abord → même ordre que la carte */

    const updates = {};
    lines.forEach((item) => { updates[item.key] = 0; });
    let done = null;
    if (Object.keys(updates).length) done = await post('cart/update.js', items.length ? { updates } : withSections({ updates }));
    if (items.length) done = await post('cart/add.js', withSections({ items }));
    await refreshUI(done && done.sections);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ng-pan-sync' });
    }
    return true;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ng-pan-qty]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const groupId = button.dataset.ngPanQtyGroup;
    const lineKey = button.dataset.ngPanKey;
    const delta = Number(button.dataset.ngPanQty);
    if (!groupId || !lineKey || ![-1, 1].includes(delta)) return;
    button.disabled = true;
    /* Quantité affichée dès le clic (le serveur confirme ensuite) ; restaurée si la mutation échoue. */
    const input = button.closest('quantity-input')?.querySelector('input');
    const before = input ? input.value : null;
    const units = [...document.querySelectorAll(`quantity-input [data-ng-pan-qty="1"][data-ng-pan-qty-group="${CSS.escape(groupId)}"]`)]
      .reduce((s, b) => s + (Number(b.closest('quantity-input')?.querySelector('input')?.value) || 0), 0);
    if (input && units + delta >= 1 && units + delta <= 3 && Number(input.value) + delta >= 1) input.value = String(Number(input.value) + delta);
    try {
      const ok = await rebuildGroup(groupId, lineKey, delta);
      if (!ok && input && before !== null) input.value = before;
    } catch (error) {
      if (input && before !== null) input.value = before;
      console.error('[NuovaGlam pan quantity]', error);
    } finally {
      button.disabled = false;
    }
  }, true);

  let running = false;
  let again = false;
  async function reconcile() {
    if (running) { again = true; return; }
    running = true;
    try {
      const cart = await readCart();
      const { updates, additions } = plan(cart);
      const changed = Object.keys(updates).length > 0 || additions.length > 0;
      let done = null;
      if (Object.keys(updates).length) done = await post('cart/update.js', additions.length ? { updates } : withSections({ updates }));
      if (additions.length) done = await post('cart/add.js', withSections({ items: additions }));
      if (changed) {
        await refreshUI(done && done.sections);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ng-pan-sync' });
      }
    } catch (error) {
      console.error('[NuovaGlam pan cart sync]', error);
    } finally {
      running = false;
      if (again) { again = false; reconcile(); }
    }
  }

  /* Bouton « supprimer » d'une ligne de lot : retire le lot entier (poêles + cadeaux) en une seule mutation. */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ng-pan-group]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const id = button.dataset.ngPanGroup;
    try {
      const cart = await readCart();
      const updates = {};
      cart.items.forEach((item) => { if (groupOf(item) === id) updates[item.key] = 0; });
      const done = Object.keys(updates).length ? await post('cart/update.js', withSections({ updates })) : null;
      await refreshUI(done && done.sections);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ng-pan-sync' });
    } catch (error) {
      console.error('[NuovaGlam pan cart sync]', error);
    }
  }, true);

  window.NuovaGlamPanCart = { plan, reconcile };
  const start = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event?.source !== 'ng-pan-sync') reconcile(); });
    }
    if (script && script.dataset.checkOnLoad === 'true') reconcile();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
